import { Policy, Proposal } from './types'

export const isPolicy = (
  proposalOrPolicy: Proposal | Policy,
): proposalOrPolicy is Policy =>
  Object.prototype.hasOwnProperty.call(proposalOrPolicy, 'policyDetail')
